import colors from "assets/theme/base/colors";

import rgba from "assets/theme/functions/rgba";
import pxToRem from "assets/theme/functions/pxToRem";

const { dark, transparent, white } = colors;

// Resolves the custom `color` prop to a hex palette color for the divider line
const lineColor = (theme, ownerState) => {
  const color = theme?.palette?.[ownerState?.color]?.main;
  return typeof color === "string" && color.startsWith("#") ? color : undefined;
};

const divider = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const color = lineColor(theme, ownerState);
      return {
        backgroundColor: color ?? (ownerState?.fullLine ? rgba(dark.main, 0.4) : transparent.main),
        backgroundImage: color
          ? `linear-gradient(to right, ${rgba(color, 0)}, ${color}, ${rgba(color, 0)}) !important`
          : ownerState?.fullLine
          ? "none"
          : `linear-gradient(to right, ${rgba(dark.main, 0)}, ${rgba(dark.main, 0.4)}, ${rgba(
              dark.main,
              0,
            )}) !important`,
        height: pxToRem(1),
        margin: `${pxToRem(16)} 0`,
        borderBottom: "none",
        opacity: color ? 1 : 0.25,
      };
    },

    vertical: ({ ownerState, theme }) => {
      const color = lineColor(theme, ownerState);
      return {
        backgroundColor: color ?? (ownerState?.fullLine ? rgba(dark.main, 0.4) : transparent.main),
        backgroundImage: color
          ? `linear-gradient(to bottom, ${rgba(color, 0)}, ${color}, ${rgba(color, 0)}) !important`
          : ownerState?.fullLine
          ? "none"
          : `linear-gradient(to bottom, ${rgba(dark.main, 0)}, ${rgba(dark.main, 0.4)}, ${rgba(
              dark.main,
              0,
            )}) !important`,
        width: pxToRem(1),
        height: "100%",
        margin: `0 ${pxToRem(16)}`,
        borderRight: "none",
      };
    },

    light: ({ ownerState, theme }) => {
      const color = lineColor(theme, ownerState);
      return {
        backgroundColor: color ?? (ownerState?.fullLine ? white.main : transparent.main),
        backgroundImage: color
          ? `linear-gradient(to right, ${rgba(color, 0)}, ${color}, ${rgba(color, 0)}) !important`
          : ownerState?.fullLine
          ? "none"
          : `linear-gradient(to right, ${rgba(white.main, 0)}, ${white.main}, ${rgba(
              white.main,
              0,
            )}) !important`,

        ...(color || ownerState?.fullLine
          ? {}
          : {
              "&.MuiDivider-vertical": {
                backgroundImage: `linear-gradient(to bottom, ${rgba(white.main, 0)}, ${
                  white.main
                }, ${rgba(white.main, 0)}) !important`,
              },
            }),
      };
    },
  },
};

export default divider;
